<app-wrapper
  [hideServices]="hideServices"
  [reloadServices]="reloadServices"
  [wrapperCssClass]="{ 'body-special': !serviceId }"
>
<!--
  <app-sidenav
    *ngIf="serviceId"
    [serviceId]="serviceId"
    [serviceName]="context.service.name"
    [defaultMyAccountServiceId]="defaultMyAccountServiceId"
  ></app-sidenav>
-->
  <div
    *ngIf="serviceNotFound"
    class="service-content {{
      store.state.common.sidemenuSmall ? 'sidemenu-small' : ''
    }} container-fluid"
  >
    <app-entity-not-found
      resource="Service"
      [id]="serviceId"
      backTo="/services"
      backLabel="Back to services">
    </app-entity-not-found>
  </div>
  <div
    *ngIf="!serviceNotFound && !isInitiating"
    class="service-content {{
      store.state.common.sidemenuSmall ? 'sidemenu-small' : ''
    }} container-fluid h-100"
  >
    <div class="row sticky-overlap-fixer">
      <div
        id="service-top-bar"
        class="col-12 service-title-container py-md-4 py-3 pl-3 px-md-5"
        *ngIf="serviceId">
        <div class="row d-flex">
          <div class="service-title flex-grow-1 col mb-3 mb-sm-0">
            <div *ngIf="!editMode" class="page-title m-0 pr-5" (click)="toggleEditMode(); $event.stopPropagation()">
              <span>{{ context.service.name }}</span>
              <i class="fas fa-pencil ml-2 editMode-pencil"></i>
              <i *ngIf="location" class="fas fa-angle-right mx-3 breadcrumb-arrow"></i>
              <span *ngIf="location">{{ location | translate }}</span>
            </div>

            <form *ngIf="editMode" class="form-controller page-title m-0">
              <input
                required
                class="form-control mr-2 mt-0 mb-0 p-1"
                type="text"
                name="serviceName"
                [(ngModel)]="context.service.name"
                placeholder="{{
                  'Type a name and press enter to submit' | translate
                }}"
                (click)="$event.stopPropagation()"
                (keypress)="submitEdit($event); $event.stopPropagation()"
                (blur)="saveEdit(); $event.stopPropagation()"
              />
            </form>
          </div>
          <div class="col-auto pl-md-0 d-flex flex-wrap justify-content-start justify-content-md-end align-content-center" style="padding-inline-end: 11px !important;">
            <div class="dropdown align-self-center dropdown mr-2 mt-md-0 p-0"
              dropdown placement="left-top">
              <button class="btn btn-ghost btn-sm" dropdownToggle>
                <i class="fa-regular fa-ellipsis-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-left-outside" *dropdownMenu>
                <div class="dropdown-item btn-default" *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel === 3">
                  <business-key *ngIf="context.service.businessKey"
                    [businessKey]="context.service.businessKey"
                    [fullButton]="true"
                    [businessKeyTooltip]="'Service business key' | translate"
                    [extraClass]="'service-context-menu-item'"> </business-key>
                </div>
                <div class="dropdown-item">
                  <a
                    routerLink="/services/{{ serviceId }}/settings"
                    target="_blank"
                    class="service-context-menu-item"
                  >
                    <i class="far text-gray fa-cog"></i>
                    {{ 'Service settings' | translate }}
                  </a>
                </div>
                <div class="dropdown-item">
                  <a
                    href="#"
                    class="service-context-menu-item"
                    (click)="openRCList(); $event.preventDefault();"
                  >
                    <i class="far text-gray fa-memo-pad"></i>
                    {{ 'Release notes' | translate }}
                  </a>
                </div>
                <div class="dropdown-item" *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel === 3">
                  <a
                    routerLink="/services/{{ serviceId }}/documentation"
                    target="_blank"
                    class="service-context-menu-item"
                  >
                    <i class="far text-gray fa-book"></i>
                    {{ 'Service tutorial' | translate }}
                  </a>
                </div>
                <div class="dropdown-divider m-0" *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel === 3"></div>
                <div class="dropdown-item" *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel === 3">
                  <a
                    href="#"
                    class="service-context-menu-item cursor-pointer"
                    (click)="openTutorial(); $event.preventDefault();"
                  >
                    <i class="far text-gray fa-circle-question"></i>
                    {{ 'Tutorial documentation' | translate }}
                  </a>
                </div>
              </div>
            </div>
            <dry-run [serviceId]="serviceId"></dry-run>
            <button *ngIf="context.service.active && this.context.service.numberOfPublishes > 0 && externalServers.length < 1"
               class="pl-0 d-flex flex-row justify-content-between align-items-center btn btn-outline-primary mx-2 py-0 btn">
                  <span (click)="goSeeService(); $event.preventDefault();" class="flex-grow-1 px-3 py-1">{{ 'service.see_service' | translate }}</span>
                  <i (click)="goSeeService(null, true); $event.preventDefault();" class="far fa-link-simple" style="font-size:0.9rem" tooltip="{{ 'service.copy_service_link' | translate }}" placement="bottom"></i>
            </button>
            <div class="dropdown align-self-center dropdown external-publish mx-2 mt-2 mt-md-0 p-0"
              *ngIf="context.service.active && this.context.service.numberOfPublishes > 0 && externalServers.length > 0"
              dropdown
              placement="bottom"
            >
              <button
              (click)="false; openDropdown(dropdown);"
              class="dropdown-toggle btn btn-outline-primary align-self-center mt-2 mt-md-0 btn-sm"
              dropdownToggle>
                <span class="d-none d-xl-inline-block">{{ 'service.see_service' | translate }}</span>
                <i class="fal fa-eye d-xl-none" tooltip="{{ 'service.see_service' | translate }}" placement="bottom"></i>
                <i class="fas fa-angle-down ml-2"></i>
                <i class="fas fa-angle-up ml-2"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                <div class="dropdown-item pl-0 d-flex flex-row justify-content-between align-items-center">
                  <span  (click)="goSeeService(); $event.preventDefault();" class="flex-grow-1 pr-4 py-2 pl-4">{{ 'locally' | translate }}</span>
                  <i (click)="goSeeService(null, true); $event.preventDefault();" class="far fa-link-simple icon-faded" style="font-size:0.9rem"></i>
                </div>
                <ng-container *ngIf="externalServers.length > 0 && existsExternalPublish()">
                  <div *ngIf="externalServers.length > 0" class="dropdown-divider m-0"></div>
                  <ng-container *ngFor="let externalServer of externalServers;">
                    <div class="dropdown-item pl-0 d-flex flex-row justify-content-between align-items-center">
                      <span (click)="goSeeService(externalServer.host); $event.preventDefault();" class="flex-grow-1 pr-4 py-2 pl-4">{{ externalServer.name }}</span>
                      <i (click)="goSeeService(externalServer.host, true); $event.preventDefault();" class="far fa-link-simple icon-faded" style="font-size:0.9rem"></i>
                  </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <a
              (click)="!this.store.state.common.lockPublishButton ?  (requestReleaseNotes ? openRCCreation() : publishService(null, null)) : null"
              *ngIf="externalServers.length == 0"
              class="btn {{this.store.state.common.runningPublications > 0 ? 'btn-warning' : 'btn-primary'}} mx-2 mt-2 mt-md-0 align-self-center"
              [ngClass]="{'blocked': isLoading, 'btn-danger': publishStatusError}"
            >
              <ng-template #publishCounterTemplate><div><span [innerHTML]="this.store.state.common.runningPublications"></span> {{'publication(s) running' | translate}}<div [innerHTML]="this.store.state.common.currentlyPublishingUsers"></div></div></ng-template>
              <span *ngIf="this.store.state.common.runningPublications > 0"
                class="publish-counter"
                [tooltip]="publishCounterTemplate"
                placement="bottom">{{this.store.state.common.runningPublications}}</span>
              <ng-template #publishTemplate><div>{{ 'Last publish date:' | translate }} {{
                getLastLocalPublish()
                  ? (getLastLocalPublish() | date: 'dd-MM-yyyy H:mm')
                  : ('never published' | translate)
              }}</div></ng-template>
              <span class="d-none d-xl-inline-block" [tooltip]="publishTemplate"
              placement="bottom">{{ 'service.publish' | translate }}</span>
              <i class="fal fa-upload d-xl-none" [tooltip]="publishTemplate"
              placement="bottom"></i>
            </a>

            <!-- publish to external server AND Request Release notes -->
            <div class="dropdown align-self-center dropdown external-publish mx-2 mt-2 mt-md-0 p-0"
                 *ngIf="externalServers.length > 0 && requestReleaseNotes"
                 dropdown
                 placement="bottom"
                 containerClass="confirmation-popover"
                 triggers="none"
            >
              <button
                      (click)="false; !this.store.state.common.lockPublishButton ? openDropdown(dropdown) : null"
                      class="dropdown-toggle align-self-center btn btn-sm btn-primary m-0 {{this.store.state.common.runningPublications > 0 ? 'btn-warning' : 'btn-primary'}} {{isLoading ? 'disabled' : ''}}"
                      dropdownToggle>
                <ng-template #publishCounterTemplate2>
                  <div><span
                          [innerHTML]="this.store.state.common.runningPublications"></span> {{'publication(s) running' | translate}}
                    <div [innerHTML]="this.store.state.common.currentlyPublishingUsers"></div>
                  </div>
                </ng-template>
                <span *ngIf="this.store.state.common.runningPublications > 0" class="publish-counter"
                      [tooltip]="publishCounterTemplate2"
                      placement="bottom">{{this.store.state.common.runningPublications}}</span>
                <span class="d-none d-xl-inline-block">{{ 'service.publish' | translate }}</span>
                <i class="fal fa-upload d-xl-none" tooltip="{{ 'service.publish' | translate }}" placement="bottom"></i>
                <i class="fas fa-angle-down ml-2"></i>
                <i class="fas fa-angle-up ml-2"></i>
              </button>
                <div class="dropdown-menu dropdown-menu-right"
                    *dropdownMenu>
                    <a (click)="applyItem(null); openRCCreation();"
                      class="dropdown-item {{isLoading ? 'disabled' : ''}}"
                       [ngClass]="{'btn-danger': publishStatusError}">
                      <span>{{ 'locally' | translate }}
                        <small class="text-muted d-block m-0">{{ 'Last publish:' | translate }} {{
                          getLastLocalPublish()
                            ? (getLastLocalPublish() | date: 'dd-MM-yyyy H:mm')
                            : ('never published' | translate)
                        }}</small>
                      </span>
                    </a>
                    <div class="dropdown-divider my-0"></div>
                    <a *ngFor="let externalServer of externalServers;" (click)="applyItem(externalServer); openRCCreation();"
                      class="dropdown-item {{isLoading ? 'disabled' : ''}}"
                      [ngClass]="{'btn-danger': publishStatusError}">
                      <span>
                        {{ externalServer.name }}
                        <small class="text-muted d-block m-0">
                          {{ 'Last publish:' | translate }} {{
                            getLastExternalPublish(externalServer.name)
                              ? (getLastExternalPublish(externalServer.name) | date: 'dd-MM-yyyy H:mm')
                              : ('never published' | translate)
                          }}
                        </small>
                      </span>
                    </a>
                </div>
            </div>

            <!-- publish to external server AND NOT Request Release notes -->
            <div class="dropdown btn {{this.store.state.common.runningPublications > 0 ? 'btn-warning' : 'btn-success'}} align-self-center btn dropdown external-publish mx-2 mt-2 mt-md-0 text-white p-0"
              *ngIf="externalServers.length > 0 && !requestReleaseNotes"
              dropdown
              [popover]="confirmationPopover"
              placement="bottom"
              popoverTitle="{{ 'general.confirm' | translate }}"
              containerClass="confirmation-popover"
              triggers="none"
              #pop="bs-popover"
              [outsideClick]="true"
            >
              <button
                      (click)="false; !this.store.state.common.lockPublishButton ? openDropdown(dropdown) : null"
                      class="dropdown-toggle align-self-center btn btn-sm m-0 {{this.store.state.common.runningPublications > 0 ? 'btn-warning' : 'btn-success'}} {{isLoading ? 'disabled' : ''}}"
                      dropdownToggle>
                <ng-template #publishCounterTemplate2>
                  <div><span
                          [innerHTML]="this.store.state.common.runningPublications"></span> {{'publication(s) running' | translate}}
                    <div [innerHTML]="this.store.state.common.currentlyPublishingUsers"></div>
                  </div>
                </ng-template>
                <span *ngIf="this.store.state.common.runningPublications > 0" class="publish-counter"
                      [tooltip]="publishCounterTemplate2"
                      placement="bottom">{{this.store.state.common.runningPublications}}</span>
                <span class="d-none d-xl-inline-block">{{ 'service.publish' | translate }}</span>
                <i class="fal fa-upload d-xl-none" tooltip="{{ 'service.publish' | translate }}" placement="bottom"></i>
                <i class="fas fa-angle-down ml-2"></i>
                <i class="fas fa-angle-up ml-2"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right"
                  *dropdownMenu>
                  <a (click)="closePopover(); applyItem(null); pop.show(); openPopover(pop);"
                    class="dropdown-item {{isLoading ? 'disabled' : ''}}"
                    [ngClass]="{'btn-danger': publishStatusError}">
                    <span>{{ 'locally' | translate }}
                      <small class="text-muted d-block m-0">{{ 'Last publish:' | translate }} {{
                        getLastLocalPublish()
                          ? (getLastLocalPublish() | date: 'dd-MM-yyyy H:mm')
                          : ('never published' | translate)
                      }}</small>
                    </span>
                  </a>
                  <div class="dropdown-divider my-0"></div>
                  <a *ngFor="let externalServer of externalServers;" (click)="closePopover(); applyItem(externalServer); pop.show(); openPopover(pop);"
                    class="dropdown-item {{isLoading ? 'disabled' : ''}}"
                    [ngClass]="{'btn-danger': publishStatusError}">
                    <span>
                      {{ externalServer.name }}
                      <small class="text-muted d-block m-0">
                        {{ 'Last publish:' | translate }} {{
                          getLastExternalPublish(externalServer.name)
                            ? (getLastExternalPublish(externalServer.name) | date: 'dd-MM-yyyy H:mm')
                            : ('never published' | translate)
                        }}
                      </small>
                    </span>
                  </a>
              </div>
            </div>
          </div>
        </div>

      </div>
      <ng-content></ng-content>
      <app-service-dashboard
        (serviceUpdated)="reloadAllServices($event)"
        *ngIf="path == '/services/' + serviceId || !serviceId"
        class="container-fluid pl-5 pr-5 h-100"
      ></app-service-dashboard>
    </div>
  </div>
</app-wrapper>
<ng-template #confirmationPopover>
  <p>{{ 'Do you want to publish this service' | translate }} «{{ externalItem ? getSelectedItem() : ('locally' | translate) }}» ?</p>
  <div class="popover-buttons">
    <primary-text-button
      [noLeftPadding]="true"
      (click)="externalItem ? publishService(null, externalItem.id) : publishService(null, null); closePopover();">
      {{'confirm.yes' | translate }}
    </primary-text-button>
    <cancelary-text-button (click)="closePopover();">
      {{'confirm.no' | translate }}
    </cancelary-text-button>
  </div>
</ng-template>
<drawer *ngIf="!serviceNotFound" [title]="context.service.name"
  [contextLabel]="'Release notes' | translate"
  [contextVariant]="'info'"
  [isClosed]="!showReleaseNotes"
  (closeEvent)="closeRNdrawer($event);"
  [hideCancel]="showReleaseNotesList ? true : false"
  [cancelLabel]="'Skip release note and publish'"
  [saveLabel]="'Publish'"
  (saveEvent)="saveReleaseNotes(false);"
  (cancelEvent)="saveReleaseNotes(true);"
  [showHeaderButtons]="showReleaseNotesList ? false : true">
  <release-notes-create *ngIf="showReleaseNotesCreation" (sendReleaseNote)="publishService($event, externalItem ? externalItem.id : null); closeRNdrawer(null);" [service]="context.service" (closeEvent)="closeRNdrawer($event);"></release-notes-create>
  <release-notes-list *ngIf="showReleaseNotesList && serviceHistory" [releases]="serviceHistory" [service]="context.service"></release-notes-list>
</drawer>
  <tutorial-layer
      *ngIf="!serviceNotFound && !isInitiating && context.service.tutorials && context.service.tutorials.general"
      #tutorialLayer
      class="d-inline-block"
      style="position: relative;"
      [forceTooltipDir]="'bottom'"
      title=""
      [showLabel]="false"
      [hideTrigger]="true"
      [isClosed]="true"
      [editorData]="context.service.tutorials.general"
      (saveTutorial)="saveTutorial($event)">
  </tutorial-layer>
